import { WhatsAppTemplate } from './whatsapp-templates.service';

const TEMPLATE_KEY_BY_REMINDER_TYPE: Record<string, string> = {
  APPOINTMENT: 'APPOINTMENT_REMINDER',
  PET_BOARDING: 'BOARDING_REMINDER',
  VACCINATION: 'VACCINATION_REMINDER',
  DEPOSIT: 'DEPOSIT_REQUEST',
  CUSTOMERS_LAST_INVOICE: 'REBOOK_REMINDER',
  PET_BIRTHDAY: 'PET_BIRTHDAY'
};

/** Same mapping as v3 resolveReminderWhatsAppTemplateKey; null when the reminder type has no WhatsApp template. */
export function resolveReminderWhatsAppTemplateKey(reminderType: string | undefined): string | null {
  return (reminderType && TEMPLATE_KEY_BY_REMINDER_TYPE[reminderType]) || null;
}

/** Same matching as v3 findWhatsAppTemplate for SYSTEM templates. */
export function findReminderWhatsAppTemplate(templates: WhatsAppTemplate[], templateKey: string): WhatsAppTemplate | undefined {
  return (templates || []).find(template => template.sourceType === 'SYSTEM'
    && (template.sourceTemplateId === templateKey || template.templateKey === templateKey));
}
